import Vue from 'vue';

export default (el) =>
  new Vue({
    el,
    components: {
      'contact-form': () => import('../contact-form/contact-form.vue'),
      'text-input-alt': () => import('../text-input-alt/text-input-alt.vue'),
      'text-area': () => import('../text-area/text-area.vue'),
    },
  });
